import addon_sensors, { sensor_addon } from '@devices/settings/device_settings/addon_sensors.js';
import scripts_gen_2 from '@devices/settings/device_settings/scripts_gen_2.js';
import virtual_components from '@devices/settings/device_settings/virtual_components.js';
import networks_gen_2_plus from '@devices/settings/device_settings/networks_gen_2_plus.js';
import webhooks_gen_2 from '@devices/settings/device_settings/webhooks_gen_2';
import app from '@devices/settings/device_settings/app';
import share from '@devices/settings/device_settings/share';
import timer_gen_2 from '@devices/settings/device_settings/timer_gen_2';
import schedule_gen_2 from '@devices/settings/device_settings/schedule_gen_2';
import settings_gen_2 from '@devices/settings/device_settings/settings_gen_2';
import output_reader_settings from '@devices/settings/common_settings/output_reader_settings';
import app_setting_gen_2 from '@devices/settings/device_settings/app_setting_gen_2';

import settings_gen_2_cct from '@devices/settings/device_settings/settings_gen_2_cct';
import night_mode_gen_2 from '@devices/settings/device_settings/night_mode_gen_2.js';
import app_setting_bulb_rgbw_gen_2 from '@devices/settings/common_settings/app_setting_bulb_rgbw_gen_2.js';
import rgbw_bulb_settings from '@devices/settings/device_settings/rgbw_bulb_settings.js';
import settings_gen_2_light from '@devices/settings/device_settings/settings_gen_2_light';
import bluetooth_bt_home_control_gen_2 from '@devices/settings/device_settings/bluetooth_bt_home_control_gen_2';
import xmod_cover_settings from '@devices/settings/device_settings/xmod_cover_settings';

export default {
	name: 'ShellyXMOD1',
	friendly_name: 'Shelly X Device',
	family: 'module',
	isPM: false,
	addons: sensor_addon,
	reset_from_input: true,
	modes: {
		shell: {
			channels: 1,
			notifications: ['offline', 'device_problem'],
			settings: [
				addon_sensors,
				scripts_gen_2,
				virtual_components,
				networks_gen_2_plus,
				bluetooth_bt_home_control_gen_2,
				share,
				{
					title: 'settings',
					components: [
						{ title: 'firmware_version', component: 'firmware_update' },
						{ title: 'geo_location_and_time_zone', component: 'location_g2' },
						{ title: 'device_name', component: 'device_name_g2' },
						{ title: 'device_reboot', component: 'device_reboot' },
						{ title: 'factory_reset', component: 'factory_reset' },
						{ title: 'device_information', component: 'device_information' },
					],
				},
			],
		},
		inputs_reader: {
			channels: 1,
			notifications: ['offline', 'device_problem', 'overtemperature'],
			settings: [
				webhooks_gen_2,
				addon_sensors,
				scripts_gen_2,
				virtual_components,
				networks_gen_2_plus,
				bluetooth_bt_home_control_gen_2,
				app,
				share,
				{
					title: 'settings',
					components: [
						{ title: 'eco_mode', component: 'eco_mode_g2' },
						{ title: 'input', component: 'input_output_g2' },
						{
							title: 'enable_input',
							component: 'enable_input_g2',
							min_ver: '1.0.7',
						},
						{ title: 'invert_input', component: 'invert_switch_g2' },
						{ title: 'firmware_version', component: 'firmware_update' },
						{ title: 'geo_location_and_time_zone', component: 'location_g2' },
						{ title: 'device_name', component: 'device_name_g2' },
						{ title: 'device_reboot', component: 'device_reboot' },
						{ title: 'factory_reset', component: 'factory_reset' },
						{ title: 'device_information', component: 'device_information' },
					],
				},
			],
		},
		relay: {
			channels: 1,
			notifications: ['offline', 'device_problem', 'forgotten_lights', 'overtemperature'],
			settings: [
				timer_gen_2,
				schedule_gen_2,
				webhooks_gen_2,
				addon_sensors,
				scripts_gen_2,
				virtual_components,
				networks_gen_2_plus,
				bluetooth_bt_home_control_gen_2,
				app_setting_gen_2,
				share,
				settings_gen_2,
			],
		},
		output_reader: {
			channels: 1,
			notifications: ['offline', 'device_problem', 'forgotten_lights', 'overtemperature'],
			settings: output_reader_settings,
		},
		cct: {
			channels: 1,
			notifications: ['offline', 'device_problem', 'forgotten_lights', 'overtemperature'],
			color_temp: { minValue: 2200, maxValue: 6000 },
			slider: 'brightness',
			brightness: 0,
			effects: false,
			settings: [
				timer_gen_2,
				schedule_gen_2,
				webhooks_gen_2,
				night_mode_gen_2,
				scripts_gen_2,
				virtual_components,
				networks_gen_2_plus,
				bluetooth_bt_home_control_gen_2,
				app_setting_gen_2,
				share,
				settings_gen_2_cct,
			],
		},
		rgbw: {
			channels: 1,
			notifications: ['offline', 'device_problem', 'forgotten_lights', 'overtemperature'],
			color: true,
			slider: 'brightness',
			brightness: 0,
			effects: false,
			settings: [
				timer_gen_2,
				schedule_gen_2,
				webhooks_gen_2,
				night_mode_gen_2,
				addon_sensors,
				scripts_gen_2,
				virtual_components,
				networks_gen_2_plus,
				bluetooth_bt_home_control_gen_2,
				app_setting_bulb_rgbw_gen_2,
				share,
				rgbw_bulb_settings,
			],
		},
		light: {
			channels: 1,
			notifications: ['offline', 'device_problem', 'forgotten_lights', 'overtemperature'],
			color: true,
			slider: 'brightness',
			brightness: 0,
			effects: false,
			settings: [
				timer_gen_2,
				schedule_gen_2,
				webhooks_gen_2,
				night_mode_gen_2,
				addon_sensors,
				scripts_gen_2,
				virtual_components,
				networks_gen_2_plus,
				bluetooth_bt_home_control_gen_2,
				app_setting_bulb_rgbw_gen_2,
				share,
				settings_gen_2_light,
			],
		},
		roller: {
			channels: 1,
			notifications: ['offline', 'device_problem', 'overtemperature'],
			slider: true,
			settings: [
				schedule_gen_2,
				webhooks_gen_2,
				addon_sensors,
				scripts_gen_2,
				virtual_components,
				networks_gen_2_plus,
				bluetooth_bt_home_control_gen_2,
				app,
				share,
				xmod_cover_settings,
			],
		},
	},
};
